import { FC, HTMLAttributes, memo } from 'react';
import cn from 'classnames';

import IconCircleChevron from '@Icons/IconCircleChevron';
import IconChevron from '@Icons/IconChevron';
import styles from './Arrow.module.css';

export interface ArrowProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  position: 'left' | 'right';
  view?: 'circle-chevron' | 'chevron';
  inversed?: boolean;
}

const Arrow: FC<ArrowProps> = (props) => {
  const { className, inversed, view = 'circle-chevron', position, ...restProps } = props;

  const iconsOfArrow = {
    chevron: <IconChevron />,
    'circle-chevron': <IconCircleChevron />,
  };

  const arrow = iconsOfArrow[view];
  return (
    <button
      {...restProps}
      type='button'
      className={cn(
        styles.arrow,
        { [styles.right]: position === 'right' },
        { [styles.chevron]: view === 'chevron' },
        { [styles.circleChevron]: view === 'circle-chevron' },
        { [styles.isArrowWhite]: inversed },
        className,
      )}
    >
      {arrow}
    </button>
  );
};

export default memo(Arrow);
